/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getTrendingTopics.defs.js'
export { main as default } from './getTrendingTopics.defs.js'
